import axios from "axios";

import { store } from "../store";

import { webUrlNode } from "../constants/appInfo";
import { clearAuth, getAuth, setAuth } from "../V2/auth/utils/authStorage";
import { refresh } from "./authApi/authApi";


/* =================================
   AXIOS INSTANCE
================================= */

const apiClient =
  axios.create({

    baseURL:
      `${webUrlNode}/api`,

    timeout: 15000
  });

/* =================================
   REQUEST
================================= */

apiClient.interceptors.request.use(

  config => {

   
    config.headers = {

  ...config.headers,

  "X-App-Domain":
    "wednessday.com"

};

    /* =========================
       ACCESS TOKEN
    ========================= */

   const auth =
  getAuth();
if (
  auth?.accessToken
) {

 
      config.headers = {

        ...config.headers,

        Authorization:
          `Bearer ${auth?.accessToken}`
      };

}

    return config;
  },

  error =>
    Promise.reject(
      error
    )
);

/* =================================
   RESPONSE
================================= */

apiClient.interceptors.response.use(
  response => response.data,

  async error => {

    const originalRequest =
      error.config;

   if (
  error?.response?.status === 401 &&
  !originalRequest._retry
) {

  originalRequest._retry = true;

  try {

    const auth =
      getAuth();

    if (!auth?.refreshToken) {
      throw new Error(
        "No refresh token"
      );
    }

    const refreshRes =
      await refresh({
        refreshToken:
          auth.refreshToken
      });

    setAuth({
      ...auth,
      accessToken:
        refreshRes.accessToken,
      refreshToken:
        refreshRes.refreshToken
    });

    originalRequest.headers.Authorization =
      `Bearer ${refreshRes.accessToken}`;

    return apiClient(
      originalRequest
    );

  } catch (err) {

    clearAuth();

    window.location.href =
      "/login";

    return Promise.reject(err);

  }

}
    return Promise.reject(error);

  }
);

export default apiClient;